// extracted by mini-css-extract-plugin
module.exports = {"products":"Products_products__1wwdc","productList":"Products_productList__WcdWU","product":"Products_product__f7Edq"};